
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick, onUnmounted, computed } from 'vue'
import { askApi } from '@/api/index'
import Table from '@/components/asktheSecretary/table.vue'
import { InfoCircleFilled } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import Nodata from '@/components/page/nodata.vue'
import stock from '@/utils/stock'
import ws from '../../websocket/index'

export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    navObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    searchObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    initInfoSecretaryTop: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    Table,
    InfoCircleFilled,
    Nodata
  },
  setup(props: any, context: any) {
    const route = useRoute()
    const gntable = ref()
    const gptable = ref()
    const pageData: any = reactive({
      Name: '',
      currentName: '',
      chartsData: [],
      maxdata: 0,
      tableData: [],
      bottomTit: { text: '近一周互动数 Top10', showPop: false },
      scrollY: 50,
      columns: [
        {
          title: '序',
          dataIndex: 'top10Index',
          key: 'top10Index',
          width: '50px',
          align: 'center',
          slots: { customRender: 'top10Index' }
        },
        {
          title: '代码',
          dataIndex: 'Inst',
          key: 'Inst',
          width: '80px',
          align: 'left',
          // sorter: (a: any, b: any) => a.Inst - b.Inst,
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'ellipsis' }
        },
        {
          title: '名称',
          dataIndex: 'Name',
          key: 'Name',
          width: '90px',
          align: 'left',
          // sorter: (a: any, b: any) => a.Name.localeCompare(b.Name, 'zh-CN'),
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'stockname' }
        },
        {
          title: '最新',
          dataIndex: 'LastPrice',
          key: 'LastPrice',
          width: '80px',
          align: 'right',
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'peopleCountColor2' }
        },
        {
          title: '涨幅',
          dataIndex: 'increase',
          key: 'increase',
          width: '70px',
          align: 'right',
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'increase' }
        },
        {
          title: '近一周互动数',
          dataIndex: 'Num',
          key: 'Num',
          width: '120px',
          align: 'right',
          defaultSortOrder: 'descend',
          // sorter: (a: any, b: any) => a.Num - b.Num,
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'hdTop' }
        }
      ],
      tableDataGN: [],
      columnsGN: [
        // 股票所属概念
        {
          title: '序',
          dataIndex: 'top10Index',
          key: 'top10Index',
          width: '50px',
          align: 'center',
          slots: { customRender: 'top10Index' }
        },
        {
          title: '名称',
          dataIndex: 'Name',
          key: 'Name',
          width: '90px',
          align: 'left',
          // sorter: (a: any, b: any) => a.Name.localeCompare(b.Name, 'zh-CN'),
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'stockname' }
        },
        {
          title: '涨幅',
          dataIndex: 'increase',
          key: 'increase',
          width: '65px',
          align: 'right',
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'increase' }
        },
        {
          title: '涨停数',
          dataIndex: 'UpLimitNum',
          key: 'UpLimitNum',
          width: '70px',
          align: 'right',
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'redInteger' }
        },
        {
          title: '涨跌分布',
          dataIndex: 'fluctuationDis',
          key: 'fluctuationDis',
          width: '100px',
          align: 'right',
          // sorter: (a: any, b: any) => a.fluctuationDis.Z - b.fluctuationDis.Z,
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          slots: { customRender: 'fluctuationDistribution' }
        },
        {
          title: '近一周互动数',
          dataIndex: 'Num',
          key: 'Num',
          width: '115px',
          align: 'right',
          // sorter: (a: any, b: any) => a.Num - b.Num,
          sorter: true,
          sortDirections: ['descend', 'ascend', 'descend'],
          defaultSortOrder: 'descend',
          slots: { customRender: 'hdTop' }
        }
      ],
      searchItem: '', // 搜索的第一个个股或者第一个关键词

      titleInfo: {
        type: '',
        Name: '',
        Inst: '',
        Exch: '',
        code: ''
      },
      websock: null,
      theme: props.theme,
      timer: null, // 1小时刷新一次近一周互动热门关键词
      gpTableH: '',
      gpTableScrollH: '',
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      key1: Math.random(),
      key2: Math.random(),
      loading1: false,
      loading2: false,
      PageID: 1,
      allTableData: [],
      pageSize: 50,
      allloaded: false,
      scrollTop: 0
    })
    pageData.gpTableH = computed(() => {
      return pageData.scrollY === 100 ? 'calc(100vh - 75px)' : 'calc(50vh - 36px)'
    })
    pageData.gpTableScrollH = computed(() => {
      if (pageData.scrollY === 50 && pageData.bottomTit.showPop) {
        return 'calc(50vh - 102px)'
      }
      return pageData.scrollY === 100 ? 'calc(100vh - 111px)' : 'calc(50vh - 70px)'
    })
    function getName(e: any) {
      if (e.target.scrollWidth > e.target.clientWidth) {
        pageData.Name = e.target.innerText
      }
    }
    function cancelName(e: any) {
      pageData.Name = ''
    }
    function top10DataFormat(val: any, init: boolean) {
      pageData.chartsData = val.KeyWordTop
      if ((pageData.chartsData || []).length) {
        pageData.maxdata = Math.ceil(pageData.chartsData[0].Num / 100) * 100
      }
      if (init) {
        val.StockTop.forEach((item: any, i: number) => {
          item.index = pageData.titleInfo.Name + i
          item.LastPrice = null
          item.increase = null
          if (i < 3) {
            item.top3 = true
          }
        })
        pageData.allTableData = val.StockTop
        subon(pageData.allTableData)
        pageData.tableData = val.StockTop
        pageData.key1 = Math.random()
        nextTick(() => {
          gptable.value.$el.querySelector('.ant-table-row') && gptable.value.$el.querySelector('.ant-table-row').click()
        })
      }
      pageData.timer && clearTimeout(pageData.timer)
      pageData.timer = setTimeout(() => {
        getTop10Data(false)
      }, 1000 * 60 * 60)
    }
    // 同时搜索个股和概念，优先选个股
    watch(
      () => props.searchObj,
      (val: any) => {
        pageData.currentName = ''
        if ((val.InstExt || []).length) {
          pageData.searchItem = val.InstExt[0]
          // defineComponent
          pageData.titleInfo.type = 'gp'
          pageData.titleInfo.Exch = pageData.searchItem.MarketCode
          pageData.titleInfo.Inst = pageData.searchItem.Code
          pageData.titleInfo.Name = pageData.searchItem.Name
          getGnAndStock()
          // getSectorlist()
        } else if ((val.KeyWords || []).length) {
          pageData.titleInfo.type = 'gn'
          pageData.searchItem = val.KeyWords[0]
          pageData.titleInfo.Name = pageData.searchItem
          getStock(true)
        }
      },
      { deep: true }
    )

    watch(
      () => props.navObj, // 左侧菜单
      async (newV: any, oldV: any) => {
        const data = props.navObj
        if (data.type === 'gn' || data.type === 'gp') {
          pageData.currentName = ''
        }
        pageData.titleInfo.type = data.type
        pageData.titleInfo.Name = data.type === 'gn' ? data.Name : data.type === 'gp' ? data.Name : '最新回答'
        pageData.titleInfo.Inst = data.type === 'gp' ? data.Symbol : ''
        pageData.titleInfo.Exch = data.type === 'gn' ? data.Exch : data.type === 'gp' ? data.Market : ''
        // 用来订阅消息
        pageData.titleInfo.code = data.type === 'gp' ? data.Symbol : data.type === 'gn' ? data.Inst : ''

        if ((newV || {}).Inst !== (oldV || {}).Inst || (newV || {}).Symbol !== (oldV || {}).Symbol) {
          suboff(pageData.allTableData)
        }
        if (props.token) {
          if (data.type === 'gn') {
            // 概念关联股
            getStock(false)
          } else if (data.type === 'gp') {
            // 股票概念 + 概念关联股
            getGnAndStock()
          } else {
            pageData.bottomTit = { text: '近一周互动数 Top10', showPop: false }
            getTop10Data(true)
          }
        }
      },
      { immediate: true, deep: true }
    )
    watch(
      () => props.initInfoSecretaryTop, // 左侧菜单加载时请求的数据，只会变化一次
      (newVal: any) => {
        const val = newVal || {}
        suboff(pageData.allTableData)
        top10DataFormat(val, true)
      }
    )
    // showPop 是否展示标题后的popover  搜索框搜索关键词——展示
    async function getStock(showPop: boolean) {
      const data = {
        KeyWords: [pageData.titleInfo.Name]
      }
      pageData.PageID = 1
      suboff(pageData.allTableData)
      pageData.allTableData = await getRela(data)
      subon(pageData.allTableData)
      pageData.bottomTit.text = pageData.titleInfo.Name + '关联股（' + (pageData.allTableData || []).length + '）'
      pageData.bottomTit.showPop = showPop
      pageData.tableData = pageData.allTableData.slice(0, pageData.pageSize)
      pageData.allloaded = pageData.tableData.length === pageData.allTableData.length
      pageData.scrollY = 100
      pageData.key1 = Math.random()
      settime()
      nextTick(() => {
        gptable.value.$el.querySelector('.ant-table-row') && gptable.value.$el.querySelector('.ant-table-row').click()
      })
    }
    async function getGnAndStock() {
      const data = {
        InstExt: [{ Exch: pageData.titleInfo.Exch, Inst: pageData.titleInfo.Inst }]
      }
      const tableDataGN = await getRela(data, true)

      suboff(pageData.tableDataGN)
      pageData.tableDataGN = tableDataGN
      pageData.scrollY = 50
      subon(pageData.tableDataGN)
      pageData.key2 = Math.random()
      if (!(pageData.tableDataGN || []).length) {
        suboff(pageData.allTableData)
        pageData.allTableData = []
        pageData.tableData = []
        pageData.key1 = Math.random()
        pageData.bottomTit.text = pageData.titleInfo.Name + '所属概念及关联股（0）'
        pageData.bottomTit.showPop = false
        return
      }
      nextTick(() => {
        gntable.value.$el.querySelector('.ant-table-row') && gntable.value.$el.querySelector('.ant-table-row').click()
      })
    }
    // 概念切换，重新请求关联股,上下表单联动
    async function clickRow(name: any) {
      const data = {
        KeyWords: [name]
      }
      pageData.PageID = 1
      suboff(pageData.allTableData)
      pageData.allTableData = await getRela(data)
      subon(pageData.allTableData)
      pageData.bottomTit.text = pageData.titleInfo.Name + '所属概念及关联股（' + (pageData.allTableData || []).length + '）'
      pageData.bottomTit.showPop = false
      pageData.tableData = pageData.allTableData.slice(0, pageData.pageSize)
      pageData.allloaded = pageData.tableData.length === pageData.allTableData.length
      pageData.key1 = Math.random()
      settime()
      nextTick(() => {
        gptable.value.$el.querySelector('.ant-table-row') && gptable.value.$el.querySelector('.ant-table-row').click()
      })
    }
    function dbClickRow(row: any) {
      stock.gotoDetail(row)
    }
    async function handclick(item: any) {
      // 单击图形后,右侧条形图下方显示「关键词关联股」表格
      context.emit('clickHotKeywords', item)
      pageData.currentName = item.Name
      const data = {
        KeyWords: [item.Name]
      }
      pageData.PageID = 1
      suboff(pageData.allTableData)
      pageData.allTableData = await getRela(data)
      subon(pageData.allTableData)
      pageData.bottomTit.text = item.Name + '关联股（' + (pageData.allTableData || []).length + '）'
      pageData.scrollY = 50
      pageData.bottomTit.showPop = true
      pageData.tableData = pageData.allTableData.slice(0, pageData.pageSize)
      pageData.allloaded = pageData.tableData.length === pageData.allTableData.length
      pageData.key1 = Math.random()
      settime()
      nextTick(() => {
        gptable.value.$el.querySelector('.ant-table-row') && gptable.value.$el.querySelector('.ant-table-row').click()
      })
    }
    let lefttimer: any = null
    function settime() {
      nextTick(() => {
        const lel: any = document.querySelector('.gp-table .ant-table-body')
        lel.addEventListener('scroll', scrollEvent)
      })
    }
    function scrollEvent(e: any) {
      const offsetHeight = e.target.offsetHeight
      const scrollTop = e.target.scrollTop
      const scrollHeight = e.target.scrollHeight
      if (offsetHeight + scrollTop - scrollHeight >= -60 && !pageData.allloaded) {
        if (!lefttimer) {
          pageData.PageID++
          pageData.scrollTop = scrollTop
          lefttimer = setTimeout(function () {
            pageData.loading2 = true
            loadData()
            lefttimer = null
          }, 200)
        }
      }
    }
    function loadData() {
      let data: any = []
      data = pageData.allTableData.slice((pageData.PageID - 1) * pageData.pageSize, pageData.PageID * pageData.pageSize)
      pageData.tableData = pageData.tableData.concat(data)
      pageData.allloaded = pageData.tableData.length === pageData.allTableData.length
      setTimeout(() => {
        pageData.loading2 = false
      }, 300)
    }
    function getRela(item: any, isLoading1?: boolean) {
      pageData.loading1 = !!isLoading1
      pageData.loading2 = true
      const data: any = {}
      data.data = {}
      data.headers = {
        token: props.token
      }
      data.data = item
      return askApi.getRela(data).then((res: any) => {
        pageData.loading1 = false
        pageData.loading2 = false
        const result = (res.Data || {}).Inst0rConceptRank || []
        result.forEach((item: any, i: number) => {
          item.index = pageData.titleInfo.Name + i
          item.LastPrice = null
          item.increase = null
          if (i < 3) {
            item.top3 = true
          }
        })

        return result
      })
    }
    // 订阅 / 取消订阅 表格数据
    // 订阅
    function subon(data: any) {
      if (!(data || []).length) return
      let stockList :Array<object> = []
      let keyList :Array<string> = []
      data.forEach((item: any) => {
        let obj= {
          symbol: item.Inst ,
          market: item.Exch,
        } as object
        let str = item.Inst+item.Exch
        stockList.push(obj)
        keyList.push(str)
      })
      console.log('订阅列表===',data)
      ws.websocket.safeSubscribeList(keyList,stockList)
    }
    // 取消订阅
    function suboff(data: any) {
      if (!(data || []).length) return
      let stockList :Array<object> = []
      let keyList :Array<string> = []
      data.forEach((item: any) => {
        let obj= {
          symbol: item.Inst ,
          market: item.Exch,
        } as object
        let str = item.Inst+item.Exch
        stockList.push(obj)
        keyList.push(str)
      })
      ws.websocket.safeUnsubscribeList(keyList,stockList)
    }
    function getTop10Data(init: any) {
      pageData.loading1 = true

      const data: any = {}
      data.data = {}
      data.headers = {
        token: props.token
      }
      init && suboff(pageData.allTableData)
      askApi.getInfoSecretaryTop(data).then((res: any) => {
        pageData.loading1 = false
        top10DataFormat(res.Data, init)
      })
    }
    onUnmounted(() => {
      clearTimeout(pageData.timer)
      pageData.timer = null
    })
    function onChange({ sorter }: any, type: any) {
      const lel: any = document.querySelector('.gp-table .ant-table-body')
      lel.scrollTop = 0
      if (sorter.column) {
        if (typeof sorter.column.sorter === 'boolean') {
          const order = sorter.order
          const tempdata = type === 'gp' ? JSON.parse(JSON.stringify(pageData.allTableData)) : JSON.parse(JSON.stringify(pageData.tableDataGN))
          const nulldata = tempdata.filter((item: any) => item[sorter.columnKey] === null)
          const filterdata = tempdata.filter((item: any) => item[sorter.columnKey] !== null)
          if (sorter.columnKey === 'Name') {
            filterdata.sort((a: any, b: any) => {
              return order === 'descend' ? b.Name.localeCompare(a.Name, 'zh-CN') : a.Name.localeCompare(b.Name, 'zh-CN')
            })
          } else if (sorter.columnKey === 'fluctuationDis') {
            filterdata.sort((a: any, b: any) => {
              return order === 'descend' ? b.fluctuationDis.Z - a.fluctuationDis.Z : a.fluctuationDis.Z - b.fluctuationDis.Z
            })
          } else {
            filterdata.sort((a: any, b: any) => {
              return order === 'descend' ? b[sorter.columnKey] - a[sorter.columnKey] : a[sorter.columnKey] - b[sorter.columnKey]
            })
          }
          if (type === 'gp') {
            // suboff(pageData.tableData)
            pageData.allTableData = order === 'descend' ? filterdata.concat(nulldata) : nulldata.concat(filterdata)
            pageData.PageID = 1
            pageData.tableData = pageData.allTableData.slice(0, pageData.pageSize)
            pageData.allloaded = pageData.tableData.length === pageData.allTableData.length
            settime()
            nextTick(() => {
              gptable.value.$el.querySelector('.ant-table-row') && gptable.value.$el.querySelector('.ant-table-row').click()
            })
          } else {
            pageData.tableDataGN = order === 'descend' ? filterdata.concat(nulldata) : nulldata.concat(filterdata)
            nextTick(() => {
              gntable.value.$el.querySelector('.ant-table-row') && gntable.value.$el.querySelector('.ant-table-row').click()
            })
          }
        }
      }
    }
    ws.websocket.on('onHQLIST', msg => {
      console.log('打印列表订阅数据===',msg)
      if (pageData.allTableData && pageData.allTableData.length) {
        pageData.allTableData.forEach((item: any) => {
          msg?.QuoteData?.DynaData?.forEach(msgItem =>{
            if (item.Inst !== msgItem.InstrumentID || item.Exch?.toLowerCase() !== msgItem.ExchangeID?.toLowerCase()) return
              item.LastPrice = msgItem.StatusType != 24 && msgItem.StatusType != 25 ? msgItem.LastPrice : null
              item.increase = msgItem.StatusType != 24 && msgItem.StatusType != 25 ? msgItem.UpdownRate*100 : null
          })
        })
      }
      if (pageData.tableDataGN && pageData.tableDataGN.length) {
        pageData.tableDataGN.forEach((item: any) => {
          msg?.QuoteData?.DynaData?.forEach(msgItem =>{
            if (item.Inst !== msgItem.InstrumentID || item.Exch?.toLowerCase() !== msgItem.ExchangeID?.toLowerCase()) return
              item.LastPrice = msgItem.StatusType != 24 && msgItem.StatusType != 25 ? msgItem.LastPrice : null
              item.increase = msgItem.StatusType != 24 && msgItem.StatusType != 25 ? msgItem.UpdownRate*100 : null
              item.UpLimitNum = msgItem.Updown || 0
              item.fluctuationDis = {
                Z: msgItem.Z || 0,
                P: msgItem.P || 0,
                D: msgItem.D || 0
              }
          })
        })
      }
    })
    return {
      ...toRefs(pageData),
      onChange,
      handclick,
      clickRow,
      dbClickRow,
      gntable,
      gptable,
      getName,
      cancelName
    }
  }
})
